/*******************************************************************************
Insert Connatix Ads
Add Connatix ads to articles and lineup pages
*******************************************************************************/

// Add a connatix ad in the set of lineups making sure to have some space between the existing 300x250 ad
function addLineupCardPlacements() {
    if ($('.lineup:not(.hide):not(.is-tools)').length >= 5 && $('.is-connatix').length === 0) {
        const extraLineupsAd = `
        <script id="ef20964059574f3b870ba418604eb7be">
            (new Image()).src = 'https://capi.connatix.com/tr/si?token=b55364c2-d257-4d07-b3c1-162dd4da5197&cid=b4491c19-2e5e-43f3-b7ea-041696b565bb';
            cnxps.cmd.push(function () {    
                cnxps({ playerId: "b55364c2-d257-4d07-b3c1-162dd4da5197" }).render("ef20964059574f3b870ba418604eb7be");  
            });
        </script>`;
        let connatixAdSlot = 3;
        const numHiddenLineups = $('.lineup.hide').length;
        if (numHiddenLineups > 0) {
            const ad300Position = $('.lineup.is-ad').index();
            const numVisibleLineups = $('.lineup:not(.hide):not(.is-tools)').length;
            connatixAdSlot = numHiddenLineups > ad300Position ? numHiddenLineups + 2 : ad300Position + 2;
            connatixAdSlot = Math.min(numVisibleLineups - 1, connatixAdSlot);
        }
        $(`.lineup:nth-child(${connatixAdSlot})`).after(`<div class="lineup is-ad is-connatix">${extraLineupsAd}</div>`);
    }

    if ($('.lineup:not(.hide):not(.is-tools)').length >= 10 && $('.is-connatix').length === 1) {
        console.log('hello');
        const extraLineupsAd = `
        <script id="713ad33a3577452eb8e94603bdacdb26">
            (new Image()).src = 'https://capi.connatix.com/tr/si?token=f5f8bc62-63e9-4799-b1eb-e2fd36fd15bf&cid=b4491c19-2e5e-43f3-b7ea-041696b565bb';  
            cnxps.cmd.push(function () {    
                cnxps({ playerId: "f5f8bc62-63e9-4799-b1eb-e2fd36fd15bf" }).render("713ad33a3577452eb8e94603bdacdb26");  
            });
        </script>`;
        let connatixAdSlot = 9;
        const numHiddenLineups = $('.lineup.hide').length;
        if (numHiddenLineups > 0) {
            const ad300Position = $('.lineup.is-ad').index();
            const numVisibleLineups = $('.lineup:not(.hide):not(.is-tools)').length;
            connatixAdSlot = numHiddenLineups > ad300Position ? numHiddenLineups + 3 : ad300Position + 3;
            connatixAdSlot = Math.min(numVisibleLineups - 1, connatixAdSlot);
        }
        $(`.lineup:nth-child(${connatixAdSlot})`).after(`<div class="lineup is-ad is-connatix">${extraLineupsAd}</div>`);
    }

}

export default function insertConnatixAds() {
    if (!window.cnxps) { return; }

    // PLAYER PAGES
    if ($('.pp-connatix-section').length > 0) {
        const playerPageAd = `
        <script id="ef20964059574f3b870ba418604eb7be">
            (new Image()).src = 'https://capi.connatix.com/tr/si?token=b55364c2-d257-4d07-b3c1-162dd4da5197&cid=b4491c19-2e5e-43f3-b7ea-041696b565bb';
            cnxps.cmd.push(function () {    
                cnxps({ playerId: "b55364c2-d257-4d07-b3c1-162dd4da5197" }).render("ef20964059574f3b870ba418604eb7be");  
            });
        </script>`;
        $('.pp-connatix-section').html(playerPageAd);
    }

    // ARTICLES
    if ($('.article__body').length > 0 && $('.article-preview-fader').length === 0) {
        const numParagraphs = $('.article__body > p').length;
        let adPlacement = 3;
        if (numParagraphs < adPlacement) { adPlacement = Math.max(numParagraphs - 1, 1); }

        const articleAd = `
        <script id="ef20964059574f3b870ba418604eb7be">
            (new Image()).src = 'https://capi.connatix.com/tr/si?token=b55364c2-d257-4d07-b3c1-162dd4da5197&cid=b4491c19-2e5e-43f3-b7ea-041696b565bb';
            cnxps.cmd.push(function () {    
                cnxps({ playerId: "b55364c2-d257-4d07-b3c1-162dd4da5197" }).render("ef20964059574f3b870ba418604eb7be");  
            });
        </script>`;
        $(`.article__body > p:nth-of-type(${adPlacement})`).after(`<p>${articleAd}</p>`);
        return;
    }

    // LINEUPS
    if ($('.lineups').length > 0) {

        // Add ad to bottom of lineups page
        /*
        const lineupsAd = `
        <script id="713ad33a3577452eb8e94603bdacdb26">
            (new Image()).src = 'https://capi.connatix.com/tr/si?token=f5f8bc62-63e9-4799-b1eb-e2fd36fd15bf&cid=b4491c19-2e5e-43f3-b7ea-041696b565bb';  
            cnxps.cmd.push(function () {    
                cnxps({ playerId: "f5f8bc62-63e9-4799-b1eb-e2fd36fd15bf" }).render("713ad33a3577452eb8e94603bdacdb26");  
            });
        </script>`;
        if ($('.page.has-gdc').length === 0) {
            $('.page').append(`<div style="width: 90%;max-width:600px;margin: 15px auto;">${lineupsAd}</div>`);
        }
        */

        // Add ad as a lineup card
        // We have to watch for the toggle-tab event on the "Hide Games That Have Started" option for each sport because
        // it messes with the positioning of the ads
        const tabSets = [
            'lineups-nfl-hidestarted',
            'lineups-mlb-hidestarted',
            'lineups-nba-hidestarted',
            'lineups-nhl-hidestarted',
            'lineups-euro-hidestarted',
            'lineups-soccer-hidestarted',
            'lineups-cricket-hidestarted',
        ];
        const tabOptions = ['Yes', 'No'];
        const eventsToWatch = [];
        tabSets.forEach((ts) => {
            tabOptions.forEach((opt) => { eventsToWatch.push(`toggleTabLoaded:${ts}-${opt}`); });
        });
        const eventsToWatchString = eventsToWatch.join(' ');
        $(document).on(eventsToWatchString, (e, tabSettings) => { addLineupCardPlacements(); });
    }
}
